import React from 'react';
import { dataScills } from '../../../const';
import './scills.sass';
//@ts-ignore
import { Progress } from 'react-sweet-progress';
import "react-sweet-progress/lib/style.css";

export const ScillsAll = () => {
    return(
        <>
        {dataScills.map((item:{texts: string, percents: string}, index: number) => {
            return(
                <div key={index} className="scill_blocs">    
                    <p>{item.texts}</p>
                    <Progress  
                        type="circle"
                        width={120}
                        percent={item.percents}
                        theme={{
                            active:{
                                color:'#ff5252',
                            }}
                        }
                    />          {/*Слайдер 15 - 24 строка, импорт слайдера 5 - 6 строка*/}          
                </div>   
            )    
        }
        )}
        </>
    )
}